export const LANGUAGE_STORAGE_KEY = 'app_language';

export const getLanguageFromStorage = (): string => {
  try {
    const storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return storedLanguage || 'ar';
  } catch (error) {
    console.warn('Failed to get language from localStorage:', error);
    return 'ar';
  }
};

export const setLanguageInStorage = (language: string): void => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch (error) {
    console.warn('Failed to save language to localStorage:', error);
  }
}; 